import type { ACLPermissions } from "~/types/ACLPermissions";
import type { Country } from "~/types/Country";
import type { Gender } from "~/types/Gender";
import type { Language } from "~/types/Language";
import type { Timezone } from "~/types/Timezone";
import type { User } from "~/types/User";
export class UserModel implements User {
  constructor(data: Partial<User>) {
    Object.assign(this, data);
  }
  id!: number;
  uuid!: string;
  name!: string;
  email!: string;
  preferred_lang!: string;
  email_verified_at!: string;
  password_updated_at!: string;
  two_factor_email!: string;
  two_factor_phone!: string;
  recovery_email!: string;
  recovery_phone!: string;
  user_token!: string;
  verified!: boolean;
  terms_of_use_id!: number;
  terms_accepted_at!: string;
  terms_use!: boolean;
  policy!: boolean;
  date_birth!: string;
  city!: string;
  country_id!: number;
  country_state_id!: null;
  language_id!: number;
  level_id!: number;
  status_id!: number;
  url_image!: string;
  last_login_date!: null;
  origin_system_id!: null;
  created_at!: string;
  updated_at!: string;
  nickname!: string;
  short_bio!: string;
  url_image_banner!: string;
  long_bio!: null;
  gender_id!: number;
  avatar_url!: string;
  first_name!: string;
  last_name!: string;
  timezone_id!: string;
  two_factor_method!: string;
  deleted_at!: null;
  invited_by_id!: null;
  invite_id!: null;
  network_uuid!: string;
  full_name!: string;
  gravatar_uri!: string;
  invite_qr_code!: string;
  linked_accounts_data!: any[];
  acl_permissions!: ACLPermissions;
  email_verified_at_formatted!: string;
  email_verified_at_diff!: string;
  email_verified_at_in_full!: string;
  email_verified_at_textual!: string;
  date_birth_formatted!: string;
  date_birth_diff!: string;
  date_birth_in_full!: string;
  date_birth_textual!: string;
  created_at_formatted!: string;
  created_at_diff!: string;
  created_at_in_full!: string;
  created_at_textual!: string;
  updated_at_formatted!: string;
  updated_at_diff!: string;
  updated_at_in_full!: string;
  updated_at_textual!: string;
  avatar_url_original_src!: string;
  avatar_url_src!: string;
  avatar_url_thumb_src!: string;
  country!: Country;
  timezone!: Timezone;
  gender!: Gender;
  language!: Language;
  can_change_nickname!: boolean;
  can_change_name!: boolean;
  has_password!: boolean;
  mgc_balance!: number;
  // Backfilled from mgc_balance in stores/auth.ts#getUser() when the API
  // response doesn't already provide it — shared-ui's MgHeaderUIUser reads
  // user.coins for the account dropdown's coins row/XP bar.
  coins?: number;
}
